"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.BinaryEvaluator = void 0;
var node_1 = require("../../node");
var booleanOperators = {
    '||': function (a, b) { return Boolean(a || b); },
    '&&': function (a, b) { return Boolean(a && b); },
    '==': function (a, b) { return a === b; },
    '!=': function (a, b) { return a !== b; },
    '<': function (a, b) { return a < b; },
    '>': function (a, b) { return a > b; },
    '<=': function (a, b) { return a <= b; },
    '>=': function (a, b) { return a >= b; }
};
var arithmeticOperators = {
    '+': function (a, b) { return a + b; },
    '-': function (a, b) { return a - b; },
    '*': function (a, b) { return a * b; },
    '/': function (a, b) { return a / b; },
    '%': function (a, b) { return a % b; },
    '**': function (a, b) { return Math.pow(a, b); }
};
var binaryOperators = __assign(__assign({}, booleanOperators), arithmeticOperators);
var BinaryEvaluator = (function (_super) {
    __extends(BinaryEvaluator, _super);
    function BinaryEvaluator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BinaryEvaluator.prototype.evaluate = function (expressionNode) {
        var left = expressionNode.left, right = expressionNode.right, operator = expressionNode.operator;
        var fn = binaryOperators[operator];
        if (!fn) {
            throw new Error("Boolean ".concat(operator, " not supported"));
        }
        var leftResult = this.evaluator.evaluateNode(left, this.context);
        var rightResult = this.evaluator.evaluateNode(right, this.context);
        var nullCount = [leftResult, rightResult].filter(function (result) { return result === null || result === undefined; }).length;
        if (operator in arithmeticOperators) {
            if (leftResult !== null &&
                leftResult !== undefined &&
                leftResult.constructor === Number &&
                rightResult !== null &&
                rightResult !== undefined &&
                rightResult.constructor === Number) {
                return fn(leftResult, rightResult);
            }
            return null;
        }
        var isValid = (operator === '||' && nullCount < 2) || nullCount === 0;
        return isValid ? fn(leftResult, rightResult) : null;
    };
    return BinaryEvaluator;
}(node_1.ExpressionNodeEvaluator));
exports.BinaryEvaluator = BinaryEvaluator;
//# sourceMappingURL=binary.js.map